'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlacesKitchen = function PlacesKitchen(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z' })
  );
};
PlacesKitchen = (0, _pure2.default)(PlacesKitchen);
PlacesKitchen.displayName = 'PlacesKitchen';
PlacesKitchen.muiName = 'SvgIcon';

exports.default = PlacesKitchen;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/places/kitchen.js
// module id = 3363
// module chunks = 0